import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	remainingTimeEstimate: {
		id: 'software.main.services.board-scope-graphql.non-critical.mobile-rest.transformer.issue.remaining-time-estimate',
		description: 'The remaining time estimate label on JSW board card tooltips',
		defaultMessage: '{value} Remaining Time Estimate',
	},
});
